import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *权重详情
 * @param classId
 * 
*/

export const getRatio = classId => Http.get(`${baseUrl}/sz/team/score/ratio/${classId}` )

/**
 *修改权重
 * @param params
 * 
*/

export const editRatio = params => Http.post(`${baseUrl}/sz/team/score/ratio`, params )
